$('.js-footerAccordion').click(function(){
	$(this).closest('has-child').toggleClass('is-open')
	$(this).next('.l-footerSitemap__subList').slideToggle();
})
